module.exports = __webpack_public_path__ + "img/wgmi-art-@2x.1ba11ed6.png";